import React from 'react';
import { Typography, Link } from '@mui/material';

type InfoMessageWithLinksProps = {
  message: string;
  onInfoClick: () => void;
  variant?: 'body1' | 'body2' | 'subtitle1' | 'subtitle2';
};

const InfoMessageWithLinks: React.FC<InfoMessageWithLinksProps> = ({ message, onInfoClick, variant = 'body2' }) => {
  const parts = message.split(/(\[.*?\])/g);

  return (
    <Typography variant={variant}>
      {parts.map((part, idx) => {
        if (part.startsWith('[') && part.endsWith(']')) {
          return (
            <Link
              key={idx}
              component="button"
              type="button"
              underline="always"
              onClick={onInfoClick}
              sx={{ cursor: 'pointer' }}
            >
              {part.slice(1, -1)}
            </Link>
          );
        }
        return part;
      })}
    </Typography>
  );
};

export default InfoMessageWithLinks;
